import { getTranslateDOMPositionXY } from 'dom-lib/lib/transition/translateDOMPositionXY';
var translateDOMPositionXY = getTranslateDOMPositionXY({
  enable3DTransform: true
});
export default translateDOMPositionXY;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite-table/es/utils/translateDOMPositionXY.js
// module id = 1061
// module chunks = 35